import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0265e883"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Comment section", -1))
const _hoisted_2 = { class: "comments-list" }

import displayComment from '../../components/CommentsSectionDisplayComment.vue';
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const newComment = ref('');
const comments = ref([
                'Cool!',
                'Love it!',
                'Horrible!'
]);

const submitComment = () => {
  comments.value.push(newComment.value);
  newComment.value = ''
}

const submitCommentFromInput = (e) => {
  if (e.keyCode !== 13) {
    return;
  }
  submitComment();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("input", {
      onKeyup: submitCommentFromInput,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newComment).value = $event)),
      type: "text",
      placeholder: "Write a comment"
    }, null, 544), [
      [_vModelText, newComment.value]
    ]),
    _createElementVNode("button", { onClick: submitComment }, "Comment!"),
    _hoisted_1,
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (comment) => {
        return (_openBlock(), _createBlock(displayComment, {
          key: comment,
          comment: comment
        }, null, 8, ["comment"]))
      }), 128))
    ])
  ]))
}
}

})